import React from "react";
import classes from "./BlockUi.module.scss";

/**
 * ローディング画面コンポーネント
 */
const BlockUi: React.FC = () => {
  return (
    <div
      className={`${classes.blockUi} d-flex flex-column align-items-center justify-content-center`}
    >
      <div className={`spinner-border ${classes.spinner}`} role="status"></div>
      <div className={`${classes.spinnerLabel}`}>Loading...</div>
    </div>
  );
};

export default BlockUi;
